import { WithAuth } from "@/hoc";
import { usePayment } from "@/hooks/usePayment";
import { InfoCircleOutlined } from "@/styles/icons";
import {
    Flex, 
} from "@chakra-ui/react";
import { Button, PageHeading } from "barte-design-system";
import { DrawerNewPaymentBatch } from "./drawer-novo-pagamento";
import { PaymentsBatchTable } from "./table-pagamentos";
import { useNavigate } from "react-router-dom";

function PagamentosLote() {
    const navigate = useNavigate();
    const { isNewPaymentBatchDrawerOpen, onNewPaymentBatchDrawerOpen, onNewPaymentBatchDrawerClose } = usePayment();

    return (
        <>
            <DrawerNewPaymentBatch
                isOpen={isNewPaymentBatchDrawerOpen}
                onClose={onNewPaymentBatchDrawerClose}
            />
            <Flex
                w="100%"
                h="100%"
                flexDir="column"
                gap="6"
            >
                <PageHeading
                    title="Histórico de pagamentos em lote"
                    primaryActionLabel="+ Enviar lote"
                    onPrimaryAction={onNewPaymentBatchDrawerOpen}
                />
                <PaymentsBatchTable />
            </Flex>
        </>
    );
}

export default WithAuth(PagamentosLote);
